import React, { PureComponent } from 'react';
import RadioButtonGeographicCode from "./RadioButtonGeographicCode";

class SelectDomicilioCorrespondencia extends PureComponent {

    render() {

        const { GET_TODOS_DOMICILIOS_ITAU, GET_CODIGO_GEOGRAFICO, Cuenta, Validaciones, ValidarPantalla, form, guardarCampoCuenta, seleccionarCombo } = this.props;
        let domicilios = [];

        /*Si los domicilios NO son de tipo string o undefined guardo el array de domcilios*/
        if (!(typeof GET_TODOS_DOMICILIOS_ITAU === "string" || !GET_TODOS_DOMICILIOS_ITAU)) {
            domicilios = GET_TODOS_DOMICILIOS_ITAU;
        }

        const domicilioSeleccionado = domicilios.find((d) => d.Direccion.CodigoDomicilio == Cuenta.DomicilioCorrespondenciaBancoTipo);
        const optionDomicilios = domicilios.map((domi, index) => {

            let { Telefono, Direccion } = domi;
            Telefono = (Telefono || {});

            const descripcion = (Direccion.CodigoDomicilio) ?
                Direccion.CodigoDomicilio + " - "
                + Direccion.Calle + ', '
                + Direccion.Numero + ', '
                + Direccion.Localidad + ', '
                + Direccion.CodigoPostal + '. (Telefono: ' + (Telefono.Caracteristica != "" ? Telefono.Caracteristica + '-' : "")
                + Telefono.Numero + ')' : Direccion.Calle;

            return (
                <option key={"select-domi-opt-" + index} value={Direccion.CodigoDomicilio}>
                    {descripcion}
                </option>
            );
        });

        let mensajeError = null;
        if (ValidarPantalla == true) {
            if (Validaciones.CodigoDomicilioSeleccionado == false) {
                mensajeError = <label className="error">Debe seleccionar un domicilio de correspondencia</label>;
            }
        }

        return (
        <div className="bottom-separator-xs">
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Domicilio para correspondencia</label>
                </div>
            </div>
            <div className="row bottom-separator-xxs">
                <div className="col-xs-6">
                    <select className="form-control default-select"
                        value={Cuenta.DomicilioCorrespondenciaBancoTipo}
                        onChange={(event) => {
                            let domicilio = domicilios.find((d) => d.Direccion.CodigoDomicilio == event.target.value);
                            seleccionarCombo(event.target.value, "DOMICILIO-CORRESPONDENCIA", domicilio);
                        }}>
                        <option value="0">Seleccione...</option>
                        {optionDomicilios}
                    </select>
                </div>
                <div className="col-xs-12">
                    {mensajeError}
                </div>

            </div>
            <div className="row">
                <div className="col-xs-12">
                    {domicilioSeleccionado &&
                        <RadioButtonGeographicCode
                            Validaciones={Validaciones}
                            ValidarPantalla={ValidarPantalla}
                            GET_CODIGO_GEOGRAFICO={GET_CODIGO_GEOGRAFICO}
                            Cuenta={Cuenta}
                            form={form}
                            domicilio={domicilioSeleccionado}
                            guardarCampoCuenta={guardarCampoCuenta}
                        />
                    }
                </div>
            </div>
        </div>
        );
    }

}

export default SelectDomicilioCorrespondencia;